import React from 'react';
import { ShimmerBox } from '../PageSkeleton/PageSkeleton';

const PathologySlideLibrarySkeleton: React.FC = () => (
    <div className="rounded-2xl overflow-hidden border border-[var(--v2-border-card)] bg-[var(--v2-bg-card)] animate-fade-in-up">

        <div className="flex items-center px-6 py-3 bg-[var(--v2-bg-surface)] border-b-2 border-[var(--v2-border-subtle)]">
            <div className="flex-1 grid" style={{ gridTemplateColumns: '2fr 1fr 1.4fr 1.3fr', columnGap: 24 }}>
                {[56, 44, 76, 52].map((w, i) => (
                    <ShimmerBox key={i} className="h-[10px] rounded" style={{ width: w }} delay={`${i * 0.05}s`} />
                ))}
            </div>
            {/* Actions header placeholder */}
            <div className="w-[200px] flex-shrink-0 flex items-center justify-center">
                <ShimmerBox className="h-[10px] w-14 rounded" delay="0.20s" />
            </div>
        </div>

        {/* ── Data rows (6 rows) ── */}
        {Array.from({ length: 6 }).map((_, r) => (
            <div
                key={r}
                className="relative flex items-center px-6 border-b border-[var(--v2-border-divider)] last:border-0"
                style={{
                    minHeight: 72,
                    background: r % 2 === 0 ? 'var(--v2-bg-card)' : 'var(--v2-bg-surface)',
                }}
            >
                {/* Left accent stripe */}
                <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-[var(--v2-border-card)] rounded-r opacity-40" />

                <div className="flex-1 grid items-center min-w-0" style={{ gridTemplateColumns: '1fr 1fr 1.4fr 1.3fr', columnGap: 24 }}>

                    {/* Patient — name + MRN */}
                    <div className="flex flex-col gap-1.5 py-3 min-w-0">
                        <ShimmerBox className="h-4 rounded-md" style={{ width: '68%' }} delay={`${r * 0.05}s`} />
                        <ShimmerBox className="h-3 rounded" style={{ width: '40%' }} delay={`${r * 0.05 + 0.03}s`} />
                    </div>

                    {/* Tests — count badge */}
                    <div className="flex items-center">
                        <ShimmerBox className="h-6 w-16 rounded-lg" delay={`${r * 0.05 + 0.06}s`} />
                    </div>

                    {/* Appointment — date + ordered sub-line */}
                    <div className="flex flex-col gap-1.5 min-w-0">
                        <ShimmerBox className="h-3.5 rounded-md" style={{ width: '80%' }} delay={`${r * 0.05 + 0.09}s`} />
                        <ShimmerBox className="h-3 rounded" style={{ width: '55%' }} delay={`${r * 0.05 + 0.11}s`} />
                    </div>

                    {/* Status — badge + 3-bar progress */}
                    <div className="flex flex-col gap-1.5 min-w-0">
                        <ShimmerBox className="h-6 w-24 rounded-lg" delay={`${r * 0.05 + 0.13}s`} />
                        {/* 3-segment progress strip */}
                        <div className="flex items-center gap-0.5" style={{ maxWidth: 72 }}>
                            {[0, 1, 2].map(seg => (
                                <ShimmerBox
                                    key={seg}
                                    className="h-[3px] flex-1 rounded-full"
                                    delay={`${r * 0.05 + 0.14 + seg * 0.02}s`}
                                />
                            ))}
                        </div>
                    </div>

                </div>

                {/* Actions — primary CTA + optional report icon */}
                <div className="flex-shrink-0 flex items-center gap-2" style={{ width: 180 }}>
                    <ShimmerBox className="h-9 flex-1 rounded-xl" delay={`${r * 0.05 + 0.18}s`} />
                    <ShimmerBox className="h-9 w-9 rounded-xl flex-shrink-0" delay={`${r * 0.05 + 0.21}s`} />
                </div>
            </div>
        ))}

        {/* ── Pagination footer ── */}
        <div className="flex items-center justify-between px-6 py-3 border-t border-[var(--v2-border-subtle)] bg-[var(--v2-bg-surface)]">
            <ShimmerBox className="h-3.5 w-32 rounded" delay="0.04s" />
            <div className="flex items-center gap-2">
                <ShimmerBox className="h-8 w-24 rounded-xl" delay="0.08s" />
                <ShimmerBox className="h-8 w-10 rounded-xl" delay="0.11s" />
                <ShimmerBox className="h-8 w-16 rounded-xl" delay="0.14s" />
            </div>
        </div>
    </div>
);

export default PathologySlideLibrarySkeleton;
